module.exports = __webpack_public_path__ + "img/mongodb.d736a80d.svg";